import { useTranslation } from 'react-i18next';

/** «Тренды» — вес vs план, недельная сводка, стрики. Этап 0: каркас. */
export function TrendsScreen(): JSX.Element {
  const { t } = useTranslation();
  return (
    <main className="screen">
      <h1 className="type-h1 screen-title">{t('trends.title')}</h1>
      <section className="card">
        <p className="type-body-15 muted" style={{ margin: 0 }}>
          {t('trends.empty')}
        </p>
      </section>
    </main>
  );
}
